"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastColors = exports.ToastPositions = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var styles = tslib_1.__importStar(require("./Toast.style"));

var Spinner_1 = tslib_1.__importDefault(require("../Spinner"));

var helper_1 = require("../../styles/helper");

var hooks_1 = require("../../hooks");

exports.ToastPositions = ['bottom', 'top'];
exports.ToastColors = ['success', 'warning', 'general', 'error'];

function Toast(_ref) {
  var style = _ref.style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      toggle = _ref.toggle,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'general' : _ref$color,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$timeoutMs = _ref.timeoutMs,
      timeoutMs = _ref$timeoutMs === void 0 ? 5000 : _ref$timeoutMs,
      _ref$insertToBody = _ref.insertToBody,
      insertToBody = _ref$insertToBody === void 0 ? true : _ref$insertToBody;

  var _react_1$useState = react_1.useState(isOpen),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isVisible = _react_1$useState2[0],
      setVisible = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      isRemoved = _react_1$useState4[0],
      setRemoved = _react_1$useState4[1];

  var _hooks_1$useWindowSiz = hooks_1.useWindowSize(),
      _hooks_1$useWindowSiz2 = _slicedToArray(_hooks_1$useWindowSiz, 1),
      innerWidth = _hooks_1$useWindowSiz2[0];

  var width = react_1.useMemo(function () {
    return innerWidth > 768 ? '430px' : 'calc(100% - 32px)';
  }, []);
  react_1.useEffect(function () {
    if (!isVisible || !toggle) {
      return;
    }

    setTimeout(function () {
      toggle(false);
    }, timeoutMs);
  }, [isVisible, timeoutMs, toggle]);
  react_1.useEffect(function () {
    setTimeout(function () {
      setVisible(false);
    }, timeoutMs);
  }, [timeoutMs]);

  function handleTransitionEnd() {
    setRemoved(true);
  }

  react_1.useEffect(function () {
    setVisible(isOpen || false);
  }, [isOpen]);

  if (insertToBody) {
    return react_dom_1.createPortal(jsx_runtime_1.jsxs("div", Object.assign({
      style: style,
      className: className,
      css: [styles.container(color, position, width), isOpen ? styles.toastShow : styles.toastHide, helper_1.getBottomSafeAreaMargin()],
      onTransitionEnd: handleTransitionEnd
    }, {
      children: [loading && jsx_runtime_1.jsx(Spinner_1.default, {
        css: styles.spinner,
        size: 20,
        color: "White"
      }, void 0), children]
    }), void 0), document.body);
  }

  if (isRemoved) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    style: style,
    className: className,
    css: [styles.container(color, position, width), isVisible ? styles.toastShow : styles.toastHide, helper_1.getBottomSafeAreaMargin()],
    onTransitionEnd: handleTransitionEnd
  }, {
    children: [loading && jsx_runtime_1.jsx(Spinner_1.default, {
      css: styles.spinner,
      size: 20,
      color: "White"
    }, void 0), children]
  }), void 0);
}

exports.default = Toast;